import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import moment from 'moment';
import Table from "react-bootstrap/Table";
import { toast } from "react-toastify";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { deleteRestoreData, getDeletedMembers } from '../ApiServices/apiHandler';
import { Navbar } from '../../../Components/Navbar';
import Loading from '../../../Components/Common/Loader/Loading';
import Sidebar from '../../../myfin_v2/elements/Sidebar';
import Breadcrumb from '../../../myfin_v2/components/Breadcrumb';
import Modal from '../../../myfin_v2/elements/Modal';
import { Button } from '../../../myfin_v2/elements/Button';
import modalcss from '../../../myfin_v2/css/modal.module.css';
import buttoncss from '../../../myfin_v2/css/button.module.css';
import SuccessModal from "../../../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../../../myfin_v2/components/connections/ErrorModal";
import commoncss from '../../../myfin_v2/css/common.module.css'
import adminPortalCss from '../../../myfin_v2/css/adminportal.module.css'
import { ReactComponent as RestoreIcon } from '../../../myfin_v2/assets/icons/restore.svg'
import { ReactComponent as CloseIcon } from '../../../myfin_v2/assets/icons/close.svg'

const DeletedIds = () => {
	const history = useHistory();
	const [deletedUsers, setDeletedUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showSuccessToaster, setShowSuccessToaster] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const [showErrorToaster, setShowErrorToaster] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
	const [displayModal, setDisplayModal] = useState(false);
	const [restoreMemberModal, setRestoreMemberModal] = useState(false);
	const [deleteMemberModal, setDeleteMemberModal] = useState(false);
	const [selectedUserId, setSelectedUserId] = useState(null);

	useEffect(() => {
		fetchDeletedMembers();
	}, [])

	const fetchDeletedMembers = () => {
		setLoading(true);
		getDeletedMembers().then(response => {
			setLoading(false);
			setDeletedUsers(response.data.fetchMembers)
		}).catch(error => {
			setLoading(false);
			showToaster(
				error.response?.data?.error || "Getting deleted members data failed!",
				"error"
			);
		})
	}

	const handleOpenRestoreModal = (u_id) => {
		setSelectedUserId(u_id);
		setDisplayModal(true);
		setRestoreMemberModal(true);
	};

	const handleCloseRestoreModal = () => {
		setDisplayModal(false);
		setRestoreMemberModal(false);
		setSelectedUserId(null);
	};

	const handleConfirmRestore = async () => {
		if (!selectedUserId) return;
		deleteRestoreData(selectedUserId).then(response => {
			showToaster("Member Restored Successfully", "success");
			handleCloseRestoreModal();
			fetchDeletedMembers();
		}).catch(error => {
			handleCloseRestoreModal();
			showToaster(
				error.response?.data?.error || "Member Restored failed!",
				"error"
			);
		});
	};

	const breadcrumbItems = [
		{
			label: "Admin Portal",
			link: `/admin`,
			className: `${commoncss.nav_cnt_color} clickable`,
		},
		{
			label: "Bin (Deleted Members)",
			link: "",
			className: "headerLable",
		},
	];

	//Toaster

	const showToaster = (message, type) => {
        if (type === "success") {
            setSuccessMessage(message);
            setShowSuccessToaster(true);
            setTimeout(() => {
                setShowSuccessToaster(false);
                setSuccessMessage("");
            }, 3000); // Hide after 3 seconds
        } else if (type === "error") {
            setErrorMessage(message);
            setShowErrorToaster(true);
            setTimeout(() => {
                setShowErrorToaster(false);
                setErrorMessage("");
            }, 3000); // Hide after 3 seconds
        }
    };

	const handleCloseSuccessToaster = () => {
        setShowSuccessToaster(false);
        setSuccessMessage("");
    };

    const handleCloseErrorToaster = () => {
        setShowErrorToaster(false);
        setErrorMessage("");
    };

	return (
		<>
			{/* <Navbar /> */}
			<div className={`${adminPortalCss.dFlex} ${adminPortalCss.dMPageWrapper}`}>
				<Sidebar />
				<div className={`${adminPortalCss.deleteMembersLayout}`}>
					<div className={adminPortalCss.dMdataLayout}>
						<Breadcrumb
							items={breadcrumbItems}
							p0={true}
							addCls="bgTransprent"
							headerActions={<></>}
						/>

						<div className={`${adminPortalCss.dMTableContainer} ${commoncss.hideScroll}`}>
							<table className={adminPortalCss.dMTable}>
								<thead>
									<tr>
										<th>Modified Date</th>
										<th>Username</th>
										<th>Email id</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{deletedUsers?.map((user, index) => (
										<tr key={index}>
											<td >
												{moment(user.updatedAt).format('DD-MMMM-YYYY')}
												{/* <sub>{moment(user.updatedAt).fromNow()}</sub> */}
											</td>
											<td>
												{user?.name}
											</td>
											<td>
												{user?.email}
											</td>
											<td className="font-sans bg-white" align="center">
												<button
													className={adminPortalCss.restoreBtn}
													onClick={() => handleOpenRestoreModal(user._id)}
												>
													<RestoreIcon />
													<span className={adminPortalCss.restoreText}>Restore</span>
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

						{/* <TableContainer className='px-3'>
							{
								loading ? <Loading /> :
									<Table aria-label="caption table">
										<TableHead className='custom-bg-gray-100' style={{ position: 'sticky', top: -1, zIndex: 1 }}>
											<TableRow>
												<TableCell align="left" className="font-sans custom-font-600 text-secondary">
													Modified Date
												</TableCell>
												<TableCell align="left" className="font-sans custom-font-600 text-secondary">
													Username
												</TableCell>
												<TableCell align="left" className="font-sans custom-font-600 text-secondary">
													Email
												</TableCell>
												<TableCell align="center" className="font-sans custom-font-600 text-secondary">
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{deletedUsers?.map((user, index) => (
												<TableRow key={index}>
													<TableCell className="font-sans bg-white text-secondary" align="left" >
														{moment(user.updatedAt).format('DD-MM-YYYY')}<br></br>
														<sub>{moment(user.updatedAt).fromNow()}</sub>
													</TableCell>
													<TableCell className="font-sans bg-white text-secondary" align="left">
														{user?.name}
													</TableCell>
													<TableCell className="font-sans bg-white text-secondary" align="left">
														{user?.email}
													</TableCell>
													<TableCell className="font-sans bg-white" align="center">
														<button
															className="d-flex justify-content-center align-items-center bg-color-inherit border-0 ml-2 h-100 w-100"
															onClick={() => RestoreMember(user._id)}
														>
															<SettingsBackupRestoreIcon
																className="text-success h-50"
															/>
															<p className="mt-0 mb-0 font-size-14 custom-font-600 text-success">
																Restore
															</p>
														</button>
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
							}
						</TableContainer> */}
					</div>
				</div>
			</div>
			{restoreMemberModal && displayModal && (
				<Modal
					headerActions={
						<CloseIcon
							onClick={handleCloseRestoreModal}
							className="clickable"
						/>
					}
					headerBottomLine={false}
					onClose={() => console.log("Modal Closed")}
				>
					<span className={`${modalcss.modalBodyHead} mb-1`}>
						Are you sure?
					</span>
					<span
						className={`${modalcss.modalBodycnt}`}
						style={{ marginBottom: "35px" }}
					>
						You will recover this member!
					</span>
					<span
						className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
					>
						<Button
							btnColor={buttoncss.secondary_del}
							label="Cancel"
							onClick={handleCloseRestoreModal}
						/>
						<Button
							btnColor={buttoncss.primary}
							label="Yes, Restore"
							onClick={handleConfirmRestore}
						/>
					</span>
				</Modal>
			)}

			{deleteMemberModal && displayModal && (
				<Modal
					headerActions={
						<CloseIcon
							onClick={() => {
								setDisplayModal(false);
								setDeleteMemberModal(false);
								setSelectedUserId(null);
							}}
							className="clickable"
						/>
					}
					headerBottomLine={false}
					onClose={() => console.log("Modal Closed")}
				>
					<span className={`${modalcss.modalBodyHead} mb-1`}>
						Do you want to <span className="fw700">delete</span> the member?
					</span>
					<span
						className={`${modalcss.modalBodycnt}`}
						style={{ marginBottom: "35px" }}
					>
						You can restore the deleted members
					</span>
					<span
						className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
					>
						<Button
							btnColor={buttoncss.danger}
							label="Yes, Delete"
							onClick={() => {
								setDisplayModal(false);
								setDeleteMemberModal(false);
								setSelectedUserId(null);
							}}
						/>
						<Button
							btnColor={buttoncss.secondary_del}
							label="No, Cancel"
							onClick={() => {
								setDisplayModal(false);
								setDeleteMemberModal(false);
							}}
						/>
					</span>
				</Modal>
			)}

			{showSuccessToaster && (
				<SuccessModal
					handleClose={handleCloseSuccessToaster}
					setSuccessModal={setShowSuccessToaster} 
					setSuccessMessage={setSuccessMessage} 
					successMessage={successMessage}
					bodycls=""
				/>
			)}

			{showErrorToaster && (
				<ErrorModal
					handleClose={handleCloseErrorToaster}
					setErrorModal={setShowErrorToaster} 
					setErrorMessage={setErrorMessage}
					errorMessage={errorMessage}
				/>
			)}
			{/* {hasMore?<button style={{border:'none',color:'#03565A',float:'right',marginRight:'3px'}} onClick={fetchMoreData}>Load more...</button>:''} */}
		</>
	)
}

export default DeletedIds;